import api from '../../tools/api-tools'
import { mainWebPostData } from '../../config/net'
import resUrl from './resource-url'
import wejs from 'weui.js'
// import './index.mock'
import store from '../../store'

class Tickets {
  stdTicketObj () {
    return {
      '3378': {
        id: '3378',
        price: '20',
        title: '新用户硬件购物券',
        descs: ['首次购买硬件可用'],
        useable: false,
        couponCode: ''
      },
      '3379': {
        id: '3379',
        price: '3',
        title: '硬件购物券',
        descs: ['首次购买硬件可用'],
        useable: false,
        couponCode: ''
      },
      '3380': {
        id: '3380',
        price: '5',
        title: '硬件购物券',
        descs: ['首次购买硬件可用'],
        useable: false,
        couponCode: ''
      },
      '3381': {
        id: '3381',
        price: '10',
        title: '硬件购物券',
        descs: ['首次购买硬件可用'],
        useable: false,
        couponCode: ''
      },
      '3382': {
        id: '3382',
        price: '18',
        title: '硬件购物券',
        descs: ['首次购买硬件可用'],
        useable: false,
        couponCode: ''
      },
      '4501': {
        id: '4501',
        price: '20',
        title: '20元赚钱型共享WiFi礼金券',
        descs: ['首次购买硬件可用'],
        useable: false,
        couponCode: ''
      },
      '4502': {
        id: '4502',
        price: '20',
        title: '20元全能收款扫码盒礼金券',
        descs: ['首次购买硬件可用'],
        useable: false,
        couponCode: ''
      }
    }
  }

  // 加载购物券
  loadData () {
    return new Promise((resolve, reject) => {
      api.get(resUrl.couponInfo).then(res => {
        let data = res.data.data
        let ticketObj = this.stdTicketObj()
        if (data) {
          for (let key of Object.keys(data)) {
            ticketObj[key]['useable'] = data[key]['canReceive']
            ticketObj[key]['couponCode'] = data[key]['couponCode']
          }
        }
        store.commit('setTicketObj', ticketObj)
        resolve({})
      }).catch(e => {
        reject(e)
      })
    })
  }

  // 领取购物券
  takeTicket (id) {
    api.post(resUrl.takeTicket + id, {}).then(res => {
      let data = res.data
      if (data.code === 0) {
        store.commit('takeTicket', {id, couponCode: data.data.couponId})
        wejs.toast('领取成功', {
          duration: 1350
        })
      } else {
        wejs.toast('领取失败', {
          duration: 1350
        })
      }
    }).catch(e => {
      wejs.toast('领取失败', {
        duration: 1350
      })
    })
  }

  // 列出我的礼金券
  usedTicketList () {
    return new Promise((resolve, reject) => {
      api.post(resUrl.mainWebUrl, mainWebPostData('getordercouponlist', 1)).then(res => {
        let model = JSON.parse(res.data.Model)
        let data = model.data || []
        let disable = '3'
        let useable1 = '2'
        let useable2 = '-1'
        let unuseable = '1'

        let ticketListObj = {
          [useable1]: [],
          [useable2]: [],
          [disable]: [],
          [unuseable]: []
        }
        // 3已作废，2尚未使用
        for (let item of data) {
          if (item.CouponStatus in ticketListObj) {
            ticketListObj[item.CouponStatus].push({
              price: item.CouponValue,
              title: item.CouponDesc,
              descs: [item.RuleTypeDesc]
            })
          }
        }
        resolve([ticketListObj[useable1].concat(ticketListObj[useable2]), ticketListObj[unuseable], ticketListObj[disable]])
      }).catch(e => {
        reject(e)
      })
    })
  }

  // v0/ordercoupon/avaliable
  orderCoupons () {
    return api.get(resUrl.orderCoupon).then(res => {
      let data = res.data.data || {}
      if (Object.keys(data).length === 0) return []
      let ticketObj = this.stdTicketObj()
      let result = []
      for (let key of Object.keys(data)) {
        ticketObj[key]['useable'] = true
        ticketObj[key]['couponCode'] = data[key]
        result.push(ticketObj[key])
      }
      return result
    }).catch(e => {
    })
  }

  // 转换服务端返回的可用优惠券到Ticket标准结构
  static ConvertCouponListModels (data = []) {
    return data.reduce((result, item) => {
      // 0代表不限制，1代表有限制
      let desc = item.RuleType === 1 ? `满${item.RuleValue}元可用` : `无限制`
      result[item.Id] = {
        id: item.Id,
        price: item.CouponValue,
        title: item.CouponDesc,
        descs: [desc],
        useable: true,
        couponCode: item.CouponId
      }
      return result
    }, {})
  }

  static SetTicket (obj) {
    store.commit('setTicketObj', obj)
  }
}

export default Tickets



// WEBPACK FOOTER //
// ./src/model/tickets/index.js